<template>
  <div class="flex flex-vertical-center flex-between step-item">
    <p class="status_label">{{ contactType.label }}</p>

    <div class="flex flex-vertical-center">
      <form-field-switch
        v-if="isSellerType"
        v-model="contactType.isDefault"
        label="Is default?"
        class="mb-0 mr-50"
        @change="updateStatus(contactType)"
        :disabled="disableDefaultSwitch"
        is-left-label
      />

      <form-field-switch
        v-model="contactType.include"
        label="Include?"
        @change="updateStatus(contactType)"
        :disabled="disableIncludeSwitch"
        is-left-label
      />
    </div>
  </div>
</template>

<script>
import {defineComponent} from 'vue'
import {ENUMS} from "../../../services/enums";

export default defineComponent({
  name: "StepItemContactType",
  props: {
    contactType: {
      type: Object,
      required: true,
    },
  },
  computed: {
    contactTypes() {
      return this.$store.state.onboarding.provisionData.types;
    },
    includedSellerTypes() {
      const allTypes = this.$store.state.onboarding.provisionData.types;
      const sellerTypes = allTypes[ENUMS.ContactTypeEnum.Seller.key];

      return sellerTypes.filter(type => type.include);
    },
    isSellerType() {
      return this.contactType.type === ENUMS.ContactTypeEnum.Seller.value;
    },
    disableIncludeSwitch() {
      if(!this.contactType.include) {
        return false
      }

      return this.isSellerType && this.includedSellerTypes.length <= 1;
    },
    disableDefaultSwitch() {
      return this.disableIncludeSwitch || !this.contactType.include;
    }
  },
  methods: {
    updateStatus( ) {
      this.$store.commit('onboarding/updateContactType', this.contactType);
    }
  },
})
</script>

<style scoped lang="scss">
@import "../../../styles/variables/variables";

.step-item {
  max-width: 440px;
  padding: 8px 0;

  &:nth-of-type(even) {
    background-color: $background;
  }
}

.status_label {
  min-width: 120px;
  padding-left: 10px;
}
</style>
